import { CardHeader, Container, Card, CardContent } from "@mui/material";
import BackButton from "../components/Buttons/BackButton";
import usePageTitle from "../hooks/usePageTitle";

export default function CardLayout({ title, children, link }) {
  // Titled pages show their title and back button in the top header
  usePageTitle(title, { back: title ? link ?? true : undefined });

  return (
    <Container>
      <Card>
        {!title && (
          <CardHeader
            title={<BackButton text={title} variant="h6" link={link} />}
          />
        )}
        <CardContent>{children}</CardContent>
      </Card>
    </Container>
  );
}
